import { render, staticRenderFns } from "./ContactsXero.vue?vue&type=template&id=068a3faa&scoped=true&"
import script from "./ContactsXero.vue?vue&type=script&lang=js&"
export * from "./ContactsXero.vue?vue&type=script&lang=js&"
import style0 from "./ContactsXero.vue?vue&type=style&index=0&id=068a3faa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068a3faa",
  null
  
)

export default component.exports